import { GenericDateFilterFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const UsersStatusDateFilterStore = GenericDateFilterFactory(GENERIC_IDS.USERS_STATUS);